module.exports = __webpack_public_path__ + "static/img/service-use04.813bb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/service-use04.png
// module id = GbLV
// module chunks = 0